import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostJackpotIssue = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_ISSUE_JACKPOT
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostJackpotIssue as SetPostJackpotIssue
}